import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const AddIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.38672 0.263184C8.939 0.263184 9.38672 0.710899 9.38672 1.26318V15.2632C9.38672 15.8155 8.939 16.2632 8.38672 16.2632C7.83443 16.2632 7.38672 15.8155 7.38672 15.2632V1.26318C7.38672 0.710899 7.83443 0.263184 8.38672 0.263184Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.386719 8.26318C0.386719 7.7109 0.834434 7.26318 1.38672 7.26318H15.3867C15.939 7.26318 16.3867 7.7109 16.3867 8.26318C16.3867 8.81547 15.939 9.26318 15.3867 9.26318H1.38672C0.834434 9.26318 0.386719 8.81547 0.386719 8.26318Z"
            fill={iconColor}
        />
    </svg>
);

export { AddIcon };